import { getAuthHeaders } from "../../../shared/services/authentication";
import { BASE_URL } from "../../../shared/utils/variables";

const baseURL = BASE_URL;

// Buscar acesso do usuário (versão 1)
export const fetchUserGetMyAccessService = async (id: string) => {
    const url = `${baseURL}/myAcess/${id}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Buscar usuário por ID
export const fetchUserByIdService = async (id: string) => {
    const url = `${baseURL}/user/${id}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Buscar lista de pesquisadores
export const fetchSearchersListService = async () => {
    const url = `${baseURL}/users-searchers`;
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Buscar acesso do usuário (versão 2)
export const getMyAccessService = async (id: string) => {
    const url = `${baseURL}/user/my-access/${id}`;
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Buscar rotas de acesso do usuário
export const getMyRoutesAccessService = async (id: string) => {
    const url = `${baseURL}/menu/routes-access/${id}`;
    
    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Solicitar atualização de plano do usuário
export const askUpdatePlanUserService = async (email: string): Promise<any> => {
    const url = `${baseURL}/upgrade-plan`;

    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
};

// Export default para facilitar importação
export default {
    fetchUserGetMyAccessService,
    fetchUserByIdService,
    fetchSearchersListService,
    getMyAccessService,
    getMyRoutesAccessService,
    askUpdatePlanUserService
};